import React from "react";
import styled from "@emotion/styled";
import {Link} from "react-router-dom";
import {getImageUrl} from "../../../context/ApplicationContextProvider";

/*
    props
    left: string
    top: string
    width: string
    height: string
    header : bool = 사용처의 여부(header에서 사용되면 true)
 */
const Logo = (props) => {
    // css style
    const {view} = useComponentStyle(props.top, props.left, props.width, props.height, props.header);

    return (
        <Link to={"/"}>
            <view.Logo />
        </Link>
    );
};

export default Logo;

export const useComponentStyle = (top, left, width, height, header) => {
    return {
        view: {
            Logo: styled.div({
                top: top ? top : "0",
                left: left ? left : "0",
                position: header && "absolute",
                background: `url(${getImageUrl("image/header/bearu_b2b_logo_x3.png")}) center center/contain no-repeat`,
                width: "9em",
                height: "100%",
                filter:
                    !header && "invert(97%) sepia(97%) saturate(0%) hue-rotate(14deg) brightness(102%) contrast(105%);",
                marginLeft: header && "10px",
            }),
        },
    };
};
